import { InjectionToken } from '@angular/core';
import { JmkwAviationConfig } from '../types/jeppesen.environment';

export const AVIATION_CONFIG_TOKEN = new InjectionToken<
  Partial<JmkwAviationConfig>
>('AVIATION_CONFIG_TOKEN');
